/** Backend `_dispatch_action` generic-completes a blank module with no Amelia reply. */
export const DEFAULT_COMPASS_ACTION_MODULE = "discuss";

export function resolveActionModule(module: string | undefined): string {
  if (module == null) return DEFAULT_COMPASS_ACTION_MODULE;
  const trimmed = module.trim();
  return trimmed === "" ? DEFAULT_COMPASS_ACTION_MODULE : trimmed;
}
